import React from 'react';

const SideBarTriggerContext = React.createContext(true);

export default SideBarTriggerContext;